import React from 'react';
import DefaultButton from '../../ReusableComponents/DefaultButton';
export default function PortalButton({ children, className = '', type = 'button', ...props }) {
  const iconOnly = className.includes('btn-sm');
  const bg = className.includes('danger')
    ? 'danger'
    : className.includes('success')
    ? 'confirm'
    : className.includes('warning')
    ? 'warning'
    : className.includes('secondary') && !className.includes('outline-secondary')
    ? 'secondary'
    : className.includes('info') || iconOnly
    ? 'info'
    : 'primary';
  return (
    <DefaultButton
      {...props}
      type={type}
      bg={bg}
      color={bg === 'warning' ? '#212529' : 'white'}
      text={children}
      padding={iconOnly ? '0' : 'auto'}
      style={
        iconOnly ? { width: '2rem', minWidth: '2rem', height: '2rem', borderRadius: 7 } : undefined
      }
    />
  );
}
